import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/signup/counselor/page.tsx");
